<template>
    <div id="StatsDisplay">
        <h4> Stats Display </h4>
        <pre>{{sortedStats}}</pre>
        <div id="buffered_log" v-html="log"></div>
    </div>
</template>
<script>
    import Hls from 'hls.js';
//    import {mapState, mapActions} from 'vuex';

    export default {
        data() {
            return {
                stats: {},
                log: '',
                tracks: []
            }
        },
        props: ['hls'],
        computed: {
            sortedStats() {
                return this.sortObject(this.stats);
            }
//            ...mapState({
//                hls: state => state.video.hls
//            })
        },
        methods: {
            sortObject(obj) {
                if (typeof obj !== 'object') return obj;
                var temp = {};
                var keys = [];
                for (var key in obj)
                    keys.push(key);
                keys.sort();
                for (var index in keys)
                    temp[keys[index]] = this.sortObject(obj[keys[index]]);
                return temp;
            },
            timeRangesToString(r) {
                var log = "";
                for (var i = 0; i < r.length; i++) {
                    log += "[" + r.start(i) + "," + r.end(i) + "]";
                }
                return log;
            },
            enableDebugInfo() {
                this.hls.on(Hls.Events.MEDIA_ATTACHED, () => {
                    this.$parent.bufferingIdx = -1;
                    this.$parent.events.video.push({time: performance.now() - this.events.t0, type: "Media attached"});
                });

                this.hls.on(Hls.Events.MEDIA_DETACHED, () => {
                    this.tracks = [];
                    this.$parent.bufferingIdx = -1;
                    this.$parent.events.video.push({time: performance.now() - this.$parent.events.t0, type: "Media detached"});
                });

                this.hls.on(Hls.Events.FRAG_PARSING_INIT_SEGMENT, (event, data) => {
                    this.$parent.events.video.push({time: performance.now() - this.$parent.events.t0, type: data.id + " init segment"});
                });

                this.hls.on(Hls.Events.BUFFER_CREATED, (event, data) => {
                    this.tracks = data.tracks;
                });

                this.hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
                    console.log("manifest successfully loaded," + this.hls.levels.length + " levels found");
                    this.stats = {levelNb: data.levels.length, levelParsed: 0, errors: {}};
                    this.$parent.refreshCanvas();
                    var event = {
                        type: "manifest",
                        name: "",
                        start: 0,
                        end: data.levels.length,
                        time: data.stats.trequest - this.$parent.events.t0,
                        latency: data.stats.tfirst - data.stats.trequest,
                        load: data.stats.tload - data.stats.tfirst,
                        duration: data.stats.tload - data.stats.tfirst,
                    };
                    this.$parent.events.load.push(event);
                });

                this.hls.on(Hls.Events.FPS_DROP, (event, data) => {
                    this.$parent.events.video.push({time: performance.now() - this.$parent.events.t0, type: "frame drop", name: data.currentDropped + "/" + data.currentDecoded});
                    if (this.stats) {
                        if (this.stats.fpsDropEvent === undefined) {
                            this.stats.fpsDropEvent = 1;
                        } else {
                            this.stats.fpsDropEvent++;
                        }
                        this.stats.fpsTotalDroppedFrames = data.totalDroppedFrames;
                    }
                });

                this.hls.on(Hls.Events.FRAG_DECRYPTED, (event, data) => {
                    if (!this.stats.fragDecrypted) {
                        this.$set(this.stats, 'fragDecrypted', 0);
                        this.$set(this.stats, 'fragAvgDecryptTime', 0);
                        this.$set(this.stats, 'totalDecryptTime', 0);
                    }
                    this.$set(this.stats, 'fragDecrypted', this.stats.fragDecrypted++);
                    this.$set(this.stats, 'totalDecryptTime', this.stats.totalDecryptTime + (data.stats.tdecrypt - data.stats.tstart));
                    this.$set(this.stats, 'fragAvgDecryptTime', (this.stats.totalDecryptTime / this.stats.fragDecrypted));
                });

                this.hls.on(Hls.Events.FRAG_LOAD_EMERGENCY_ABORTED, (event, data) => {
                    if (this.stats) {
                        if (this.stats.fragLoadEmergencyAborted === undefined) {
                            this.$set(this.stats, 'fragLoadEmergencyAborted', 1);
                        } else {
                            this.$set(this.stats, 'fragLoadEmergencyAborted', this.stats.fragLoadEmergencyAborted++);
                        }
                    }
                });

                this.hls.on(Hls.Events.FRAG_CHANGED, (event, data) => {
                    this.$set(this.stats, 'tagList', data.frag.tagList);

                    var level = data.frag.level, autoLevel = data.frag.autoLevel;
                    if (this.stats.levelStart === undefined) {
//                        stats.levelStart = level;
                        this.$set(this.stats, 'levelStart', level);
                    }
                    if (autoLevel) {
                        if (this.stats.fragChangedAuto) {
                            this.$set(this.stats, 'autoLevelMin', Math.min(this.stats.autoLevelMin, level));
                            this.$set(this.stats, 'autoLevelMax', Math.max(this.stats.autoLevelMax, level));
                            this.$set(this.stats, 'fragChangedAuto', this.stats.fragChangedAuto++);
                            if (this.levelLastAuto && level !== this.stats.autoLevelLast) {
                                this.$set(this.stats, 'autoLevelSwitch', this.stats.autoLevelSwitch++);
                            }
                        } else {
                            this.sumAutoLevel = 0;
                            this.$set(this.stats, 'autoLevelMin', level);
                            this.$set(this.stats, 'autoLevelMax', level);
                            this.$set(this.stats, 'autoLevelSwitch', 0);
                            this.$set(this.stats, 'fragChangedAuto', 1);
                        }
                        this.sumAutoLevel += level;
                        this.$set(this.stats, 'autoLevelAvg', Math.round(1000 * level / this.stats.fragChangedAuto) / 1000);
                        this.$set(this.stats, 'autoLevelLast', level);
                    } else {
                        if (this.stats.fragChangedManual) {
                            this.$set(this.stats, 'manualLevelMin', Math.min(this.stats.manualLevelMin, level));
                            this.$set(this.stats, 'manualLevelMax', Math.max(this.stats.manualLevelMax, level));
                            this.$set(this.stats, 'fragChangedManual', this.stats.fragChangedManual++);

                            if (!this.levelLastAuto && level !== this.stats.manualLevelLast) {
                                this.$set(this.stats, 'manualLevelSwitch', this.stats.manualLevelSwitch++);
                            }
                        } else {
                            this.$set(this.stats, 'manualLevelMin', level);
                            this.$set(this.stats, 'manualLevelMax', level);
                            this.$set(this.stats, 'manualLevelSwitch', 0);
                            this.$set(this.stats, 'fragChangedManual', 1);
                        }
                        this.$set(this.stats, 'manualLevelLast', level);
                    }
                    this.levelLastAuto = autoLevel;
                    this.$parent.events.video.push({time: performance.now() - this.$parent.events.t0, type: 'frag changed', name: data.frag.sn + ' @ ' + data.frag.level});
                    this.checkBuffer();
                    this.$parent.refreshCanvas();
                });

                this.hls.on(Hls.Events.FRAG_BUFFERED, (event, data) => {
                    var latency = data.stats.tfirst - data.stats.trequest,
                        parsing = data.stats.tparsed - data.stats.tload,
                        process = data.stats.tbuffered - data.stats.trequest,
                        bitrate = Math.round(8 * data.stats.length / (data.stats.tbuffered - data.stats.tfirst));
                    if (this.stats.fragBuffered) {
                        this.$set(this.stats, 'fragMinLatency', Math.min(this.stats.fragMinLatency, latency));
                        this.$set(this.stats, 'fragMaxLatency', Math.max(this.stats.fragMaxLatency, latency));
                        this.$set(this.stats, 'fragMinProcess', Math.min(this.stats.fragMinProcess, process));
                        this.$set(this.stats, 'fragMaxProcess', Math.max(this.stats.fragMaxProcess, process));
                        this.$set(this.stats, 'fragMinKbps', Math.min(this.stats.fragMinKbps, bitrate));
                        this.$set(this.stats, 'fragMaxKbps', Math.max(this.stats.fragMaxKbps, bitrate));
                        this.$set(this.stats, 'autoLevelCappingMin', Math.min(this.stats.autoLevelCappingMin, this.hls.autoLevelCapping));
                        this.$set(this.stats, 'autoLevelCappingMax', Math.max(this.stats.autoLevelCappingMax, this.hls.autoLevelCapping));
                        this.$set(this.stats, 'fragBuffered', this.stats.fragBuffered++);
                    } else {
                        this.$set(this.stats, 'fragMinLatency', latency);
                        this.$set(this.stats, 'fragMaxLatency', latency);
                        this.$set(this.stats, 'fragMinProcess', process);
                        this.$set(this.stats, 'fragMaxProcess', process);
                        this.$set(this.stats, 'fragMinKbps', bitrate);
                        this.$set(this.stats, 'fragMaxKbps', bitrate);
                        this.$set(this.stats, 'fragBuffered', 1);
                        this.$set(this.stats, 'fragBufferedBytes', 0);
                        this.$set(this.stats, 'autoLevelCappingMin', this.hls.autoLevelCapping);
                        this.$set(this.stats, 'autoLevelCappingMax', this.hls.autoLevelCapping);
                        this.sumLatency = 0;
                        this.sumKbps = 0;
                        this.sumProcess = 0;
                        this.sumParsing = 0;
                    }
                    this.$set(this.stats, 'fraglastLatency', latency);
                    this.sumLatency += latency;
                    this.$set(this.stats, 'fragAvgLatency', Math.round(this.sumLatency / this.stats.fragBuffered));
                    this.$set(this.stats, 'fragLastProcess', process);
                    this.sumProcess += process;
                    this.sumParsing += parsing;
                    this.$set(this.stats, 'fragAvgProcess', Math.round(this.sumProcess / this.stats.fragBuffered));
                    this.$set(this.stats, 'fragLastKbps', bitrate);
                    this.sumKbps += bitrate;
                    this.$set(this.stats, 'fragAvgKbps', Math.round(this.sumKbps / this.stats.fragBuffered));
                    this.$set(this.stats, 'fragBufferedBytes', this.stats.fragBufferedBytes + data.stats.total);
                    this.$set(this.stats, 'fragparsingKbps', Math.round(8 * this.stats.fragBufferedBytes / this.sumParsing));
                    this.$set(this.stats, 'fragparsingMs', Math.round(this.sumParsing));
                    this.$set(this.stats, 'autoLevelCappingLast', this.hls.autoLevelCapping);

                    var event = {
                        type: data.frag.type + " fragment",
                        id: data.frag.level,
                        id2: data.frag.sn,
                        time: data.stats.trequest - this.$parent.events.t0,
                        latency: data.stats.tfirst - data.stats.trequest,
                        load: data.stats.tload - data.stats.tfirst,
                        parsing: data.stats.tparsed - data.stats.tload,
                        buffer: data.stats.tbuffered - data.stats.tparsed,
                        duration: data.stats.tbuffered - data.stats.tfirst,
                        bw: Math.round(8 * data.stats.total / (data.stats.tbuffered - data.stats.trequest)),
                        size: data.stats.total
                    };
                    this.$parent.events.load.push(event);
                    this.$parent.events.bitrate.push({time: performance.now() - this.$parent.events.t0, bitrate: event.bw, duration: data.frag.duration, level: event.id});
//                    console.log(this.$parent.events.bitrate);
                    if (this.hls.bufferTimer === undefined) {
                        this.$parent.events.buffer.push({time: 0, buffer: 0, pos: 0});
                        this.hls.bufferTimer = window.setInterval(this.checkBuffer, 100);
                    }
                    this.$parent.refreshCanvas();
                });

                this.hls.on(Hls.Events.LEVEL_SWITCHED, (event, data) => {
                    this.$parent.refreshCanvas();
                    this.$parent.events.level.push({time: performance.now() - this.$parent.events.t0, id: data.level, bitrate: Math.round(this.hls.levels[data.level].bitrate / 1000)});
                });

                this.hls.on(Hls.Events.LEVEL_LOADED, (event, data) => {
//                    console.log('data.details.totalduration', data.details.totalduration);
                    const parsingDuration = data.stats.tparsed - data.stats.tload;
                    if (this.stats.levelParsed) {
                        this.sumLevelParsingMs += parsingDuration;
                    } else {
                        this.sumLevelParsingMs = parsingDuration;
                    }
                    this.$set(this.stats, 'levelParsed', this.stats.levelParsed++);
                    this.$set(this.stats, 'levelParsingUs', Math.round(1000 * this.sumLevelParsingMs / this.stats.levelParsed));

                    this.$set(this.$parent.events, 'isLive', data.details.live);
                    var event = {
                        type: "level",
                        id: data.level,
                        start: data.details.startSN,
                        end: data.details.endSN,
                        time: data.stats.trequest - this.$parent.events.t0,
                        latency: data.stats.tfirst - data.stats.trequest,
                        load: data.stats.tload - data.stats.tfirst,
                        parsing: data.stats.tparsed - data.stats.tload,
                        duration: data.stats.tload - data.stats.tfirst
                    };
                    this.$parent.events.load.push(event);
                    this.$parent.refreshCanvas();
                });
            },
            checkBuffer() {
                var v = this.$parent.$parent.player;
                var r = v.buffered;
                var bufferingDuration;
                if (r) {
                    var pos = v.currentTime;
                    var bufferLen;
                    for (var i = 0, bufferLen = 0; i < r.length; i++) {
                        if (pos >= r.start(i) && pos < r.end(i)) {
                            bufferLen = r.end(i) - pos;
                        }
                    }

                    if (bufferLen <= 0.1 && v.paused === false && (pos - this.$parent.lastStartPosition) > 0.5) {
                        if (this.$parent.lastDuration - pos <= 0.5 && this.$parent.events.isLive === false) {
                        } else {
                            if (this.$parent.bufferingIdx !== -1) {
                                bufferingDuration = performance.now() - this.$parent.events.t0 - this.$parent.events.video[this.$parent.bufferingIdx].time;
                                this.$set(this.$parent.events.video[this.$parent.bufferingIdx], 'duration', bufferingDuration);
                                this.$set(this.$parent.events.video[this.$parent.bufferingIdx], 'name', bufferingDuration);
                            } else {
                                this.$parent.events.video.push({type: 'buffering', time: performance.now() - this.$parent.events.t0});
                                // we are in buffering state
                                this.$parent.bufferingIdx = this.$parent.events.video.length - 1;
                            }
                        }
                    }

                    if (bufferLen > 0.1 && this.$parent.bufferingIdx != -1) {
                        bufferingDuration = performance.now() - this.$parent.events.t0 - this.$parent.events.video[this.$parent.bufferingIdx].time;
                        this.$set(this.$parent.events.video[this.$parent.bufferingIdx], 'duration', bufferingDuration);
                        this.$set(this.$parent.events.video[this.$parent.bufferingIdx], 'name', bufferingDuration);
                        // we are out of buffering state
                        this.$parent.bufferingIdx = -1;
                    }

                    // update buffer/position for current Time
                    var event = {time: performance.now() - this.$parent.events.t0, buffer: Math.round(bufferLen * 1000), pos: Math.round(pos * 1000)};
                    var bufEvents = this.$parent.events.buffer, bufEventLen = bufEvents.length;
                    if (bufEventLen > 1) {
                        var event0 = bufEvents[bufEventLen - 2], event1 = bufEvents[bufEventLen - 1];
                        var slopeBuf0 = (event0.buffer - event1.buffer) / (event0.time - event1.time);
                        var slopeBuf1 = (event1.buffer - event.buffer) / (event1.time - event.time);

                        var slopePos0 = (event0.pos - event1.pos) / (event0.time - event1.time);
                        var slopePos1 = (event1.pos - event.pos) / (event1.time - event.time);
                        // compute slopes. if less than 30% difference, remove event1
                        if ((slopeBuf0 === slopeBuf1 || Math.abs(slopeBuf0 / slopeBuf1 - 1) <= 0.3) &&
                            (slopePos0 === slopePos1 || Math.abs(slopePos0 / slopePos1 - 1) <= 0.3)) {
                            bufEvents.pop();
                        }
                    }
                    this.$parent.events.buffer.push(event);
                    this.$parent.refreshCanvas();


                    var log = "Duration:"
                        + v.duration + "<br>"
                        + "Buffered:"
                        + this.timeRangesToString(v.buffered) + "<br>"
                        + "Seekable:"
                        + this.timeRangesToString(v.seekable) + "<br>"
                        + "Played:"
                        + this.timeRangesToString(v.played) + "<br>";

                    if (this.hls.media) {
                        for (var type in this.tracks) {
                            log += type + " Buffered:" + this.timeRangesToString(this.tracks[type].buffer.buffered) + "<br>";
                        }
                        var videoPlaybackQuality = v.getVideoPlaybackQuality;
                        if (videoPlaybackQuality && typeof(videoPlaybackQuality) === typeof(Function)) {
                            log += "Dropped Frames:" + v.getVideoPlaybackQuality().droppedVideoFrames + "<br>";
                            log += "Corrupted Frames:" + v.getVideoPlaybackQuality().corruptedVideoFrames + "<br>";
                        } else if (v.webkitDroppedFrameCount) {
                            log += "Dropped Frames:" + v.webkitDroppedFrameCount + "<br>";
                        }
                    }

                    this.log = log;
                }
            }
        }
    }
</script>
<style>
    #StatsDisplay {
        /*position: absolute;*/
        /*top: 0;*/
        /*z-index: 9999;*/
        background: #607D8B;
        /*height: 100%;*/
        overflow: scroll;
        padding: 30px;
    }

    #StatsDisplay pre {
        margin-bottom: 40px;
    }

    div#buffered_log {
        margin-bottom: 60px;
    }
</style>


// WEBPACK FOOTER //
// DebugStats.vue?33abf45e